"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _FixedSessionWrapper = _interopRequireDefault(require("./FixedSessionWrapper"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var match = {
  FixedSessionWrapper: _FixedSessionWrapper["default"]
};
var _default = exports["default"] = function _default(_ref) {
  var _ref$extraProps = _ref.extraProps,
    extraProps = _ref$extraProps === void 0 ? {} : _ref$extraProps;
  return function (WrappedComponent) {
    var _Class;
    return _Class = /*#__PURE__*/function (_React$Component) {
      _inherits(_Class, _React$Component);
      function _Class() {
        _classCallCheck(this, _Class);
        return _callSuper(this, _Class, arguments);
      }
      _createClass(_Class, [{
        key: "render",
        value: function render() {
          var _this = this;
          var tabList = [];
          AppDefs.sessions.sessionTabs.forEach(function (s) {
            var Component = match[s.componentHandle];
            var sessions = [];
            s.sessions.forEach(function (sessionHandle) {
              var fullSession = (0, _find2["default"])(AppDefs.sessions["".concat(AppDefs.sessions.sessionType, "Settings")].sessions, function (session) {
                return session.handle === sessionHandle;
              });
              sessions.push(fullSession);
            });
            tabList.push({
              name: s.handle,
              title: s.label,
              content: /*#__PURE__*/_react["default"].createElement(Component, _extends({
                key: s.handle,
                appDefData: AppDefs.sessions,
                sessionData: sessions,
                pawn: _this.props.pawn
              }, Object.assign({}, (0, _omit2["default"])(_this.props, ['loading']), extraProps, s.componentProps)))
            });
          });
          var sessionDataComponent = {};
          if (this.props.loading) {
            sessionDataComponent = /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
              loading: this.props.loading
            });
          } else if (this.props.clients.length === 0) {
            sessionDataComponent = /*#__PURE__*/_react["default"].createElement("div", null, "No ".concat(extraProps.clientLabel, "s at this time."));
          } else {
            sessionDataComponent = /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
              tabList: tabList
            });
          }
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(WrappedComponent, this.props), sessionDataComponent);
        }
      }]);
      return _Class;
    }(_react["default"].Component), _defineProperty(_Class, "propTypes", {
      // props from wrapped component
      pawn: _propTypes["default"].object,
      loading: _propTypes["default"].bool,
      clients: _propTypes["default"].array
    }), _Class;
  };
};